import React from 'react';
import PropTypes from 'prop-types';
import {getDownloadUrl} from "@web/lib/cloud.storage";

StorageFile.propTypes = {
  storageURI: PropTypes.string.isRequired,
  dataField: PropTypes.string,
};

function StorageFile({storageURI, dataField, children, ...props}) {
  const [src, setFileUrl] = React.useState("");

  React.useEffect(() => {
    if (!storageURI?.startsWith("gs://")) {
      setFileUrl(storageURI);
      return;
    }
    getDownloadUrl(storageURI)
      .then((url) => setFileUrl(url))
  }, [storageURI]);

  return React.cloneElement(
    React.Children.only(children),
    {[dataField || "src"]: src, ...props},
  )
}

const MemoizedComponent = React
.memo(
  StorageFile,
  (prevProps, nextProps) => {
    return prevProps.storageURI === nextProps.storageURI;
  });

export default MemoizedComponent;
